export default __webpack_public_path__ + "static/media/dekstop.67bf13c1.png";